<template>
  <div>
    

    <Dialog
      :visible.sync="passwordDialog1"
      :style="{ width: '600px', height: '323px' }"
      header=""
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="a">New Password</label>
          <InputText 
            id="a"  
            v-model.trim="newPassword" 
            type="password"
          />
          <small
            class="p-invalid"
            v-if="submitted && !newPassword"
            >New Password is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="a">Confirm New Password</label>
          <InputText 
            id="b"  
            v-model.trim="confirmNewPassword" 
            type="password"
          />
          <small
            class="p-invalid"
            v-if="submitted && !confirmNewPassword"
            >Confirm New Password is required.</small
          >
        </div>
      </div>
      
      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-text"
              @click="$emit('close')"
            />
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Save"
              icon="pi pi-check"
              class="p-button-text"
              @click="save"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    passwordDialog: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    newPassword: '',
    confirmNewPassword: '',
    submitted: false
  }),
  computed: {
    passwordDialog1: {
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
      get() {
        return this.passwordDialog
      }
    }
  },
  methods: {
    save() {
      this.submitted = true
      
      if (
        this.newPassword && 
        this.confirmNewPassword && 
        this.newPassword.length > 5 &&
        this.confirmNewPassword.length > 5 &&
        this.newPassword === this.confirmNewPassword
      ) {
        this.$emit('save', this.newPassword)
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Warning",
          detail: "New and confirm passwords must be equal and length should be at least 6.",
          life: 5000,
        })
      }
    }
  }
}
</script>

<style>

</style>